import {
  Factory,
  QuickFactory,
  StandardEntity,
} from '@infodata-group/inf-commons';
import { Fleet } from '../model/new-fleet';
import { FleetDto } from '../interface/fleet.dto';

export class FleetFactory extends QuickFactory implements Factory<Fleet> {
  build(o: FleetDto): Fleet {
    const fleet: Fleet = new Fleet();
    this.generateProperty(fleet, o);
    if (o.group) {
      fleet.group = new StandardEntity(o.group.id, o.group.label, 'label');
    }
    return fleet;
  }

  getApi(): string {
    return 'administration/fleet/';
  }
}
